import { CommonRequestOptions, makeRequest } from '../makeRequest';

export enum CourseAssigneesOrderBy {
   USERNAME = 'username',
   COURSE_STATUS = 'status',
   STAGE_PROGRESS = 'stage_progress',
   DATE_ASSIGNED = 'assignment_date',
   DUE_DATE = 'due_date',
   DATE_COMPLETED = 'course_completion_date',
   RECURRENCE_DATE = 'recurrence_date',
}

export enum CourseAssigneeCompletionStatus {
   NOT_STARTED = 'Not Started',
   IN_PROGRESS = 'In Progress',
   COMPLETED = 'Completed',
}

export type CourseAssignee = {
   userid: number;
   username: string;
   user_avatar: string;
   total_stages: number;
   due_date: number | null;
   assignment_date: number;
   completed_stages: number;
   recurrence_date: number | null;
   course_completion_date: number | null;
   status: CourseAssigneeCompletionStatus;
};

export type CourseAssigneesOptions = {
   page?: number;
   limit?: number;
   orderby?: CourseAssigneesOrderBy;
   direction?: 'ASC' | 'DESC';
   statusFilter?: CourseAssigneeCompletionStatus[];
   search?: string;
};

export type CourseAssigneesResponse = {
   response: Array<CourseAssignee>;
   hasMore: boolean;
   totalAssignees: number;
};

export async function getCourseAssignees(
   wikiid: number,
   options?: CourseAssigneesOptions,
   common: CommonRequestOptions = {}
): Promise<CourseAssigneesResponse> {
   const {
      page = 1,
      limit = 10,
      orderby = CourseAssigneesOrderBy.USERNAME,
      direction = 'ASC',
      statusFilter,
   } = options ?? {};

   let queryParams = `page=${page}&limit=${limit}&orderby=${orderby}&direction=${direction}`;

   const parsedStatus = statusFilter
      ?.map(status => status.replace(' ', '_').toLowerCase())
      .join(',');
   parsedStatus && (queryParams += `&status=${parsedStatus}`);

   queryParams += options?.search ? `&search=${options.search}` : '';

   return await makeRequest('get', `course_assignees/course/${wikiid}/users?${queryParams}`, {
      ...common,
   });
}
